<qvs-login-page-header></qvs-login-page-header>
<form class="qvs-login-form" [formGroup]="loginForm" (ngSubmit)="sendContractNr($event)">
  <p class="qvs-login-form__label">{{ 'ebanking.login.LABEL' | translate }}</p>
  <ion-item class="qvs-login-form__contract-number" lines="none">
    <ion-input
      class="qvs-login-form__contract-number__input"
      formControlName="contractNumber"
      type="text"
      placeholder="{{ 'ebanking.login.INPUT_PLACEHOLDER' | translate }}"
    ></ion-input>
  </ion-item>

  <ion-button class="qvs-login-form__button" expand="block" type="submit" [disabled]="isButtonDisabled()">{{
    'ebanking.login.BUTTON' | translate
  }}</ion-button>
  <p class="qvs-login-form__registration-cta">
    <span>{{ 'ebanking.login.GO_TO_REGISTRATION_TEXT' | translate }}</span>
    <button class="qvs-login-form__registration-button" type="button" (click)="goToRegistration()">
      {{ 'ebanking.login.GO_TO_REGISTRATION_BUTTON' | translate }}
    </button>
  </p>
  <qvs-info-box *ngIf="maintenanceAnnouncement$ | async as msg" [text]="msg" class="qvs-login-form__info-box"></qvs-info-box>
</form>
